import * as React from 'react';
import classnames from '../../../_virtual/index.js';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { TealiumButton } from '@grandvisionhq/svc-tealium/components';
import { useGetWishlist } from '../../../hooks/use-get-wishlist.js';
import { getWishlisted } from '../utils/get-wishlisted.js';

const AnonymousWishlistButton = ({ sku , localWishlistId , isUpdateLoading , onWishlistClick , disabled , tabIndex  })=>{
    const { data , loading  } = useGetWishlist();
    const isWishlisted = getWishlisted(sku, data === null || data === void 0 ? void 0 : data.items);
    const { getLabel  } = useIntl();
    const isDisabled = loading || disabled;
    const wishlistButtonAriaLabel = isWishlisted ? getLabel('account.wishlist.buttonLabel.remove') : getLabel('account.wishlist.buttonLabel.add');
    return /*#__PURE__*/ React.createElement(TealiumButton, {
        onClick: (event)=>{
            onWishlistClick(isWishlisted ? 'remove' : 'add', localWishlistId, event);
        },
        disabled: isDisabled,
        className: classnames('wishlist-button', {
            'wishlist-button--disabled': isDisabled,
            'wishlist-button--wishlisted': isWishlisted || isUpdateLoading
        }),
        "aria-disabled": isDisabled,
        "aria-label": wishlistButtonAriaLabel,
        tabIndex: tabIndex,
        tealiumEvent: {
            data_element_id: isWishlisted ? 'Prod_RemoveFromWishList' : 'Prod_AddToWishList'
        },
        caption: /*#__PURE__*/ React.createElement(Icon, {
            name: isWishlisted || isUpdateLoading ? 'favourite-filled' : 'favourite-empty'
        }),
        variant: "ghost",
        size: "custom",
        noHover: true
    });
};

export { AnonymousWishlistButton as default };
//# sourceMappingURL=AnonymousWishlistButton.js.map
